<template>
  <div class="flex" style="width: 100%; justify-content: space-between">
    <Hamburger
      :is-active="appStore.sidebar.opened"
      @toggle-click="toggleSideBar"
    />
    <div class="flex">
      <!-- 功能按钮 -->
      <img
        v-if="isShowHelpCenter"
        src="@/assets/icon/QuestionFilled-icon.png"
        @click="toHelp"
        alt=""
        class="mr-40 header-icon"
      />
      <el-badge
        :is-dot="isNoRead > 0"
        class="Bell-count f jcc"
        v-if="isShowMessage"
      >
        <img
          src="@/assets/icon/Bell-icon.png"
          @click="toMessage"
          alt=""
          class="mr-40 header-icon"
        />
      </el-badge>
      <!-- 权限设置 -->
      <el-dropdown
        trigger="click"
        @command="toSysRoute"
        v-if="sysMenuList?.length"
      >
        <img
          src="@/assets/icon/Setting-icon.png"
          alt=""
          class="mr-40 header-icon"
        />
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="item in sysMenuList"
              :key="item.menuId"
              :command="item?.name"
            >
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <!-- 用户头像 -->
      <el-dropdown
        class="nav-action-item"
        trigger="click"
        popper-class="top-nav-dropdown"
      >
        <div class="flex-center">
          <el-icon color="#8291A9" size="24px" style="margin-right: 8px"
            ><Avatar
          /></el-icon>
          <span>{{ appUserStore.userInfo.name }}</span>
          <span
            class="triangle"
            style="margin-left: 8px; margin-right: 16px"
          ></span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="myInformation" v-if="isShowInformation">
              我的资料
            </el-dropdown-item>
            <el-dropdown-item @click="toLogout"> 退出登录 </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
  <!--消息中心 -->
  <MessageCenter ref="messageCenterRef" />
</template>
<script setup lang="ts">
import { ElMessageBox, ElMessage } from "element-plus";
import { loginOut } from "@/api/login";
import { useAppStore, useUserStore, usePermissionStore } from "@/stores";
import { useRouter } from "vue-router";
import Hamburger from "../../Sidebar/components/Hamburger.vue";
import MessageCenter from "@/components/messageCenter/index.vue";
import { permissionMpping } from "@/utils/permission";
const appStore = useAppStore();
const appUserStore = useUserStore();
const permissionStore = usePermissionStore();
const isNoRead = computed(() => {
  return appStore.isNoRead;
});
console.log(isNoRead.value);
const router = useRouter();
const messageCenterRef = ref();
function toggleSideBar() {
  appStore.toggleSidebar();
}
const reversedObj = {};
for (const key in permissionMpping) {
  const value = permissionMpping[key];
  reversedObj[value] = key;
}
console.log(reversedObj);
// 消息中心
const isShowMessage = computed(() => {
  return (
    permissionStore.btnAuthArr?.indexOf(permissionMpping["messageLook"]) !== -1
  );
});
//  帮助中心
const isShowHelpCenter = computed(() => {
  return (
    permissionStore.btnAuthArr?.indexOf(permissionMpping["helpLook"]) !== -1
  );
});

//  我的资料
const isShowInformation = computed(() => {
  return (
    permissionStore.btnAuthArr?.indexOf(permissionMpping["informationLook"]) !==
    -1
  );
});
console.log(isShowMessage.value);
const sysMenuList = computed(() => {
  let data: any = permissionStore?.menuList?.find(
    (item: any) => item.menuId && item.menuId === "1894191048087130112",
  );

  return data?.childMenuNodeRespList;
});
const toMessage = () => {
  messageCenterRef.value?.openMessage();
};
const toSysRoute = (name: string) => {
  console.log(name);
  switch (name) {
    case "角色权限":
      router.push({
        path: "/permission/role",
      });
      break;
    case "人员管理":
      router.push({
        path: "/permission/menber",
      });
      break;
    case "客户管理":
      router.push({
        path: "/customerManagement",
      });
      break;
    case "邀请记录":
      router.push({
        path: "/inviteHistory",
      });
      break;
    case "LOGO定制":
      router.push("/logoList");
      break;
  }
};
/**
 * 注销登出
 */
function toLogout() {
  ElMessageBox.confirm("确定退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    lockScroll: false,
  }).then(() => {
    loginOut()
      .then(() => {
        localStorage.clear();
        sessionStorage.clear();
        router.replace("/login");
        // permissionStore.resetRouter();
        // location.reload();
      })
      .catch((err) => {
        console.log(err);
        ElMessage.error("退出失败");
      });
  });
}
// 我的资料
function myInformation() {
  router.push({
    path: "/myInformation",
  });
}
function toHelp() {
  router.push({
    path: "/helpCenter",
  });
}
</script>
<style lang="scss" scoped>
:deep(.el-badge__content.is-fixed.is-dot) {
  right: 45px;
  top: 0px;
}
.nav-action-item {
  display: inline-block;
  min-width: 40px;
  height: $navbar-height;
  line-height: $navbar-height;
  color: var(--el-text-color);
  text-align: center;
  cursor: pointer;
}
.header-icon {
  width: 20px;
  height: 20px;
}
.mr-40 {
  margin-right: 40px;
  color: #262626;
  cursor: pointer;
}
.dark .nav-action-item:hover {
  background: rgb(255 255 255 / 20%);
}
.flex {
  display: flex;
  align-items: center;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 10px;
  margin-left: 20px;
}
.rounded-full {
  border-radius: 50%;
  margin-right: 10px;
  width: 24px;
  height: 24px;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #c5cae2;
}
.shopping-cart {
  border-right: 1px solid rgba(130, 145, 169, 0.53);
  padding: 0 24px;
  .svg-icon {
    width: 22px;
    height: 20px;
  }
}
</style>
